import React, { createContext, useReducer } from "react";
import { colors } from "../../../TypesAndConstants/colorPalette";
import { initState } from "../../../TypesAndConstants/const";

interface ColorState {
  paletteMenuIsOpen: boolean;
  colors: string[];
  colorPalettes: string[][];
  pickerPos: { x: number; y: number };
  cachedPos?: { x: number; y: number };
}

type colorActions =
  | "set_color"
  | "set_palette_open"
  | "set_palette"
  | "set_picker_pos"
  | "set_cached_pos";

export type dispatchColorAction = {
  type: colorActions;
  value: any;
};

export const colorReducer = (
  state: ColorState = initStateColors,
  action: dispatchColorAction
): ColorState => {
  switch (action.type) {
    case "set_picker_pos":
      return {
        ...state,
        pickerPos: action.value
      };
    case "set_cached_pos":
      return { ...state, cachedPos: action.value };
    case "set_color":
      return {
        ...state,
        colors: [action.value]
      };
    case "set_palette_open":
      return {
        ...state,
        paletteMenuIsOpen: action.value
      };
    case "set_palette":
      return {
        ...state,
        colors: state.colorPalettes[action.value]
      };
    default:
      return state;
  }
};

export const initStateColors: ColorState = {
  paletteMenuIsOpen: false,
  pickerPos: { x: 130, y: 71 },
  colors: initState.brushColor,
  colorPalettes: colors
};

export const ColorContext = createContext<{
  state: ColorState;
  dispatch: (action: dispatchColorAction) => void;
}>({
  state: initStateColors,
  dispatch: () => {}
});

export const ColorContextConsumer = ColorContext.Consumer;

export const ColorContextProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(colorReducer, initStateColors);

  return (
    <ColorContext.Provider value={{ state, dispatch }}>
      {children}
    </ColorContext.Provider>
  );
};
